var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 371.75916,
    width: 279.17993,
    viewBox: "0 0 279.17993 371.75914",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1775.1174,-80.350707)",
    id: "g82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 1891.974,88.478 c 5.321,2.826 11.276,5.061 15.27,9.791 -5.941,37.642 -33.734,67.004 -10.656,72.947 10.771,0.49 21.571,-0.216 32.357,0.346 -18.281,31.659 -31.271,47.543 -30.641,52.63 -0.389,5.912 5.552,10.396 11.016,10.887 7.375,-1.488 7.443,-3.404 48.78,-70.683 3.417,-5.696 -1.399,-11.737 -6.344,-14.448 -12.992,-1.182 -26.171,0.764 -39.105,-1.053 7.195,-18.471 13.309,-37.346 20.288,-55.875 6.176,-19.7 130.012,-29.628 120.877,79.234 -2.285,32.992 -13.525,46.244 -14.03,60.503 -0.166,43.296 1.47,34.252 -9.2,96.321 -15.88,64.967 -50.948,111.685 -74.144,121.9 -4.802,0.707 -9.776,0.75 -14.549,-0.058 -4.21,-2.48 -8.623,-5.724 -10.281,-10.454 -1.172,-24.977 8.712,-34.537 7.584,-73.538 0.713,-49.674 -28.518,-97.83 -46.055,-25.868 -0.966,9.603 -3.865,19.005 -3.071,28.752 -0.865,10.252 2.624,20.129 2.797,30.338 1.37,13.871 8.825,27.324 5.148,41.484 -31.035,48.393 -110.222,-81.064 -107.755,-179.923 -0.115,-5.09 0.36,-10.252 -0.461,-15.299 -1.759,-6.791 1.918,-13.698 0.043,-20.475 -52.284,-123.764 47.268,-164.903 102.132,-137.459 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrack);
export default __webpack_public_path__ + "static/media/crack.399519b8c1edd461b36002ad3e65b6b8.svg";
export { ForwardRef as ReactComponent };